/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  useState,
  useContext,
  useEffect,
  ChangeEvent,
  useCallback,
} from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import CasesAPI from 'api/CasesAPI';
import UsersAPI from 'api/UsersAPI';
import { useSnackbar } from 'notistack';
import { Redirect, useHistory } from 'react-router-dom';
import DBModuleHeaderLayout from 'components/Common/Layouts/DBModuleHeaderLayout';
import ScreeningInfo from 'components/BiteDB/ScreeningInfo';
import BiteDBAPI from 'api/BiteDBAPI';
import { IScreeningResultRow } from 'interfaces/IBiteDB';

interface TeamKeys {
  name: string;
  id: string;
}
const ScreeningPage: React.FC = (props: any) => {
  const { cur_user } = useContext(GlobalContext);
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [autoTab, setAutoTab] = useState<string>('');
  const [cardTab, setCardTab] = useState<string>('Card');
  const [userHasMonitor, setUserHasMonitor] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [selectedCase, setSelectedCase] = useState<any>({});
  const [ownerEmail, setOwnerEmail] = useState('');
  const [cases, setCases] = useState<{
    isLoaded: boolean;
    data: any[];
    error: string | undefined;
  }>({ isLoaded: false, data: [], error: undefined });
  const [cur_case, setCase] = useState<{
    isLoaded: boolean;
    error: string | undefined;
    data: any;
  }>({ isLoaded: false, error: undefined, data: {} });
  const [apiCases, setApiCases] = useState<{
    isLoaded: boolean;
    data: any[];
    error: string | undefined;
  }>({ isLoaded: false, data: [], error: undefined });
  const [docCases, setDocCases] = useState<{
    isLoaded: boolean;
    data: any[];
    error: string | undefined;
  }>({ isLoaded: false, data: [], error: undefined });
  const [screeningResults, setScreeningResults] = useState<{
    isLoaded: boolean;
    data: IScreeningResultRow[];
    error: string | undefined;
  }>({ isLoaded: false, data: [], error: undefined });

  const handleTabSwitch = (newTab: string) => {
    switch (newTab) {
      case 'Dashboard':
        setAutoTab('Dashboard');
        window.sessionStorage.setItem('autoTab', 'Dashboard');
        break;
      case 'Databases':
        setAutoTab('Databases');
        window.sessionStorage.setItem('autoTab', 'Databases');
        break;
      case 'People & Companies':
        setAutoTab('People & Companies');
        window.sessionStorage.setItem('autoTab', 'People & Companies');
        break;
      case 'Products':
        setAutoTab('Products');
        window.sessionStorage.setItem('autoTab', 'Products');
        break;
      default:
        setAutoTab('Dashboard');
    }
  };

  const requiredTiers = [
    'pro',
    'business',
    'enterprise',
    'database',
    'tariff database',
  ];

  const checkSubscription = () => {
    if (cur_user.quickcodeOnly) {
      setUserHasMonitor(true);
      return;
    }
    if (
      requiredTiers.some((role) =>
        cur_user.selected_team?.attributes?.tier.includes(role),
      )
    ) {
      setUserHasMonitor(true);
    }
  };

  const getScreeningResultsForGroup = useCallback(async () => {
    try {
      const selected_team_id = cur_user?.selected_team?.id;
      if (!selected_team_id) {
        enqueueSnackbar('Please select a team', { variant: 'error' });
        return;
      }
      const response = await BiteDBAPI.getScreeningResultsForGroup(
        selected_team_id,
      );
      if (response?.success) {
        setScreeningResults({
          isLoaded: true,
          data: response.result,
          error: undefined,
        });
      } else {
        enqueueSnackbar(
          `Error fetching screening results: ${response?.result}`,
          { variant: 'error' },
        );
      }
    } catch (e) {
      console.error('Error fetching screening results:', e);
      enqueueSnackbar('Failed to fetch screening results', {
        variant: 'error',
      });
    }
  }, [cur_user?.selected_team?.id, enqueueSnackbar]);

  useEffect(() => {
    if (cur_user.quickcodeOnly) {
      setUserHasMonitor(true);
      getScreeningResultsForGroup();
      return;
    }
    checkSubscription();
    getScreeningResultsForGroup();
  }, [cur_user.quickcodeOnly, getScreeningResultsForGroup]);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const getOwner = async (id: string) => {
    const res = await UsersAPI.getUser(id);
    if (res?.success) {
      return res?.result.basics.email;
    }
    return '';
  };

  useEffect(() => {
    const fetchOwner = async () => {
      if (!selectedCase || !selectedCase._id) {
        return;
      } // Prevent running when empty

      CasesAPI.getCase(selectedCase._id)?.then(async (res: any) => {
        if (res?.success) {
          if (
            res.result.owner?.email !== cur_user.basics?.email &&
            !res.result.sharedWith.includes(cur_user.basics?.email) &&
            !res.result.sharedWith.includes(cur_user.basics?.id) &&
            !(res.result.createdBy === cur_user.basics?.id)
          ) {
            history.push('/');
          }

          setCase({ isLoaded: true, error: undefined, data: res.result });

          if (res.result.owner) {
            setOwnerEmail(res.result.owner?.email);
          } else {
            const email = await getOwner(res.result.createdBy);
            setOwnerEmail(email);
          }
        } else {
          const err_text = `Error loading case: ${res?.result}`;
          enqueueSnackbar(err_text, { variant: 'error' });
        }
      });
    };

    fetchOwner();
  }, [selectedCase]);

  const helpContent = (
    <p className='module-header-tooltip-text'>
      Quickly search for high risk people, companies and products as well as
      cyber threat indicators. Filter by Lens for more accuracy
    </p>
  );

  return (
    <DBModuleHeaderLayout
      title='Screening Settings'
      helpContent={helpContent}
      hubLabel='BITE DB'
      hubTo='/bite-db/entities'
    >
      <div>
        <ScreeningInfo
          tabs={
            props.location.state?.linkTab
              ? props.location.state?.linkTab
              : 'Run Screening'
          }
          screeningResults={screeningResults.data}
        />
      </div>
    </DBModuleHeaderLayout>
  );
};

export default ScreeningPage;
